module.exports = __webpack_public_path__ + "static/media/G1-40-Tamesis-Acalântis-cod81-B.9df9b212.png";